function ebdCollectionPagePlan(products, page, pageSize) {
  const indexed = products.map((product, index) => ({ ...product, sourcePage: Math.floor(index / pageSize) + 1 }));
  const ordered = indexed.filter(product => product.available).sort((a, b) => (a.priority ?? 999) - (b.priority ?? 999)).concat(indexed.filter(product => !product.available));
  return ordered.slice((page - 1) * pageSize, page * pageSize);
}

if (typeof module !== 'undefined' && module.exports) module.exports = { ebdCollectionPagePlan };
if (typeof document !== 'undefined') (() => {
  async function initialize(root) {
    if (root.dataset.stockInitialized) return;
    root.dataset.stockInitialized = 'true';
    const grid = root.querySelector('.col-grid');
    const status = root.querySelector('[data-stock-status]');
    const size = Number(root.dataset.pageSize);
    if (!grid || Number(root.dataset.productCount) <= size) { root.dataset.stockReady = 'true'; return; }
    const page = Number(root.dataset.currentPage);
    const section = root.closest('.shopify-section').id.replace('shopify-section-', '');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    const request = async (sectionId, number) => {
      const url = new URL(location.href);
      url.hash = '';
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('page', String(number));
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Collection request failed');
      return new DOMParser().parseFromString(await response.text(), 'text/html');
    };
    const readIndex = async number => {
      const doc = await request('ebd-collection-stock-index', number);
      const node = doc.querySelector('[data-ebd-stock-index]');
      if (!node) throw new Error('Collection index missing');
      return JSON.parse(node.textContent);
    };
    root.dataset.stockPending = 'true';
    grid.setAttribute('aria-busy', 'true');
    status.hidden = false;
    try {
      const first = await readIndex(1);
      const products = first.products;
      for (let number = 2; number <= first.pages; number++) products.push(...(await readIndex(number)).products);
      if (products.length !== first.total || new Set(products.map(product => product.id)).size !== products.length) throw new Error('Collection index incomplete');
      const plan = ebdCollectionPagePlan(products, page, size);
      const cards = new Map(Array.from(grid.querySelectorAll('[data-product-id]')).map(card => [card.dataset.productId, card]));
      const neededPages = [...new Set(plan.filter(product => !cards.has(product.id)).map(product => product.sourcePage))];
      for (let offset = 0; offset < neededPages.length; offset += 3) {
        const docs = await Promise.all(neededPages.slice(offset, offset + 3).map(number => request(section, number)));
        docs.forEach(doc => doc.querySelectorAll('.col-grid [data-product-id]').forEach(card => cards.set(card.dataset.productId, card)));
      }
      const ordered = plan.map(product => {
        const card = cards.get(product.id);
        if (!card || (card.dataset.available === 'true') !== product.available) throw new Error('Collection availability changed');
        return card;
      });
      if (!ordered.length) throw new Error('Collection page empty');
      ordered.forEach((card, index) => { const image = card.querySelector('img'); if (image) image.loading = index < 4 ? 'eager' : 'lazy'; });
      grid.replaceChildren(...ordered);
      root.dataset.stockReady = 'true';
    } catch (error) {
      root.dataset.stockReady = 'fallback';
    } finally {
      clearTimeout(timeout);
      delete root.dataset.stockPending;
      grid.removeAttribute('aria-busy');
      status.hidden = true;
    }
  }
  const start = () => document.querySelectorAll('[data-ebd-stock-order]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
